import type { FC } from "react";
import React from "react";
import { Box, Flex } from "@edreamsodigeo/prisma-design-system";
import { Desktop, Mobile } from "@edreamsodigeo/frontend-core";

import type { LightboxOfferWrapperProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/contracts";

export const LightboxOfferSubscriptionWrapper: FC<
  LightboxOfferWrapperProps
> = ({ children, color }) => (
  <>
    <Mobile>
      <Flex flexDirection={"column"}>{children}</Flex>
    </Mobile>
    <Desktop>
      <Box
        backgroundColor={color}
        sx={{ width: "135px" }}
        p={"base"}
        py={"1x_small"}
      >
        {children}
      </Box>
    </Desktop>
  </>
);
